import { cn } from "../../Utils/helper";
import images from "./../../images";

export const ObjectiveOption = ({
  text,
  isSelected,
  onClick,
  className,
  handleEditObjective,
  showEditButton = false,
  handleEdit,
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        `flex gap-2.5 justify-between items-center px-5 py-2.5 rounded-full border-2  border-solid ${
          isSelected ? "border-black bg-black text-white" : "border-black"
        } h-[60px] w-full text-left transition-colors focus:outline-none max-sm:px-4 max-sm:py-2`,
        className
      )}
      aria-pressed={isSelected}
    >
      <div className="flex gap-2.5 flex-row items-center justify-between w-full">
        {" "}
        <div className="flex flex-row gap-2 items-center">
          <span className="flex-shrink-0">
            {isSelected ? (
              <img src={images.CheckIconWhite} alt="" className="w-[16px]" />
            ) : null}
          </span>
          <span className="text-sm tracking-wide ">{text}</span>
        </div>
        <span className="flex-shrink-0">
          {showEditButton ? (
            <img
              onClick={handleEditObjective}
              src={images.PencilIconWhite}
              alt=""
              className="w-[16px]"
            />
          ) : (
            ""
          )}
        </span>
      </div>
      {/* <span className="flex-shrink-0">
        {showEditButton ? (
          <button
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering onClick of the parent
              handleEditObjective();
            }}
            className="text-indigo-600 hover:text-indigo-800"
          >
            <img src={images.PencilIconWhite} alt="Edit" className="w-4 h-4" />
          </button>
        ) : (
          <div></div>
        )}
      </span> */}
    </button>
  );
};
